import React, { useContext as useContextCore, useState } from 'react'
import type { AiChatReportPage, PivotField, PivotLayout, PivotLoadedDays } from '@ztechapps/common.contract'

/** The pivot report open on screen — what the chat needs to describe it and apply a layout to it. */
export type OpenPivot = {
  report: string
  fields: PivotField[]
  layout: PivotLayout
  loadedDays: PivotLoadedDays[]
  headerFilters: string[]
  apply: (layout: PivotLayout) => void
  /** Exact-name programmatic entry to the page's header-filter chain; unknown names no-op. */
  switchHeaderFilter: (headerFilter: string) => void
}

export type OpenPivotContextType = {
  openPivot?: OpenPivot
  reportPages: AiChatReportPage[]
  registerOpenPivot?: (openPivot?: OpenPivot) => void
}
const context = React.createContext<OpenPivotContextType>({} as OpenPivotContextType)

export type OpenPivotProviderProps = { children: React.ReactNode; reportPages: AiChatReportPage[] }

/** Holds the open pivot report above the chat bubble, so the routed page can register it and the bubble can read it. */
export const OpenPivotProvider = ({ children, reportPages }: OpenPivotProviderProps) => {
  const [openPivot, setOpenPivot] = useState<OpenPivot | undefined>(undefined)
  return (
    <context.Provider value={{ openPivot, reportPages, registerOpenPivot: setOpenPivot }}>{children}</context.Provider>
  )
}

/** Reads the open pivot context. */
export const useOpenPivotContext = () => useContextCore(context)
